import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useRestParametersQuery } from './useRestParametersQuery';
import { useRestParametersTableState } from './useRestParametersTableState';

export const useRestParametersTable = () => {
    const { t } = useTranslation();
    const { rows, setRows, loading, setLoading, loadData } = useRestParametersQuery();
    const { contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = useRestParametersTableState();

    const start_by = useMemo(
        () => ({
            midnight: t('settings.break_rules.dialog.inputs.start_break_by_data.midnight'),
            planned_start_time: t('settings.break_rules.dialog.inputs.start_break_by_data.planned_start_time'),
            real_start_time: t('settings.break_rules.dialog.inputs.start_break_by_data.real_start_time'),
        }),
        [t],
    );

    const columns: GridColDef[] = [
        { field: 'name', headerName: t('settings.break_rules.table.columns.name'), flex: 1 },
        { field: 'duration_normal', headerName: t('settings.break_rules.table.columns.duration_normal'), flex: 1, headerAlign: 'center', align: 'center', filterable: false },
        { field: 'duration_max', headerName: t('settings.break_rules.table.columns.duration_max'), flex: 1, headerAlign: 'center', align: 'center', filterable: false },
        { field: 'start_break_amount_pay', headerName: t('settings.break_rules.table.columns.start_break_amount_pay'), flex: 1, headerAlign: 'center', align: 'center', filterable: false },
        {
            field: 'start_break_by',
            headerName: t('settings.break_rules.table.columns.start_break_by'),
            flex: 1,
            filterable: false,
            renderCell: (params) => {
                return start_by[String(params.value) as keyof typeof start_by] || params.value;
            },
        },
    ];

    const reloading = useCallback(() => {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') as string[];
        const canReadBreakRules = permissions.includes('timekeeper.BreakRule');

        if (canReadBreakRules) {
            loadData().finally(() => {
                setContextMenu(null);
                cleanSelected();
            });
        } else {
            setRows([]);
            setLoading(false);
        }
    }, [cleanSelected, loadData, setContextMenu, setLoading, setRows]);

    return { columns, rows, setRows, loading, setLoading, loadData, contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected, reloading };
};
